import { useLang } from "../context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section data-testid="marquee" className="py-10 md:py-14 bg-foreground text-background overflow-hidden">
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="font-serif-ed italic text-4xl md:text-6xl px-8 flex items-center gap-8">
            {w}
            <span className="text-accent text-2xl md:text-3xl not-italic">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
